/* eslint-disable react/prop-types */
import React from "react";
import {
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBCol,
	MDBRow,
	MDBView,
} from "mdbreact";

export default function BannerCarousel({ banners = [], bannerLength = "12" }) {
	if (banners.length > 0) {
		if (bannerLength !== "12") {
			return (
				<MDBRow>
					{banners.map((banner, index) => (
						<MDBCol sm="12" md={bannerLength} key={"banner_" + index}>
							{banner.link ? (
								<a href={banner.link}>
									<img
										className="d-block w-100 img-fluid"
										src={banner.image}
										alt={banner.alt || ""}
									/>
								</a>
							) : (
								<img
									className="d-block w-100 img-fluid"
									src={banner.image}
									alt={banner.alt || ""}
								/>
							)}
						</MDBCol>
					))}
				</MDBRow>
			);
		}

		return (
			<MDBCarousel
				activeItem={1}
				length={banners.length}
				showControls={banners.length > 1}
				showIndicators={false}
				className="z-depth-1 shadow-none my-2"
			>
				<MDBCarouselInner>
					{banners.map((banner, index) => (
						<MDBCarouselItem key={"banner_" + index} itemId={index + 1}>
							<MDBView>
								{banner.link ? (
									<a href={banner.link}>
										<img
											className="d-block w-100 img-fluid"
											src={banner.image}
											alt={banner.alt || ""}
										/>
									</a>
								) : (
									<img
										className="d-block w-100 img-fluid"
										src={banner.image}
										alt={banner.alt || ""}
									/>
								)}
							</MDBView>
						</MDBCarouselItem>
					))}
				</MDBCarouselInner>
			</MDBCarousel>
		);
	}

	return <></>;
}
